<template>
  <pre class="my-0" v-if="formattedJson"><code class="language-json pa-0">{{formattedJson}}</code></pre>
</template>

<script>
import Prism from 'prismjs';
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-json'

export default {
  name: "JsonViewer",

  props: {
    jsonData: {
      required: true,
    }
  },

  computed: {
    formattedJson() {
      const data = this.jsonData;

      const isArray = Array.isArray(data);
      const isObject = typeof data === 'object' && data !== null && !isArray;

      if (!data) return false;
      if (!isArray && !isObject) return false;

      return JSON.stringify(data, null, 2);
    },
  },

  mounted() {
    Prism.highlightAll();
  },

  updated() {
    Prism.highlightAll();
  }
}
</script>
